import { render, staticRenderFns } from "./DigitalHumanSwitcher.vue?vue&type=template&id=487b4cd6&scoped=true"
import script from "./DigitalHumanSwitcher.vue?vue&type=script&lang=js"
export * from "./DigitalHumanSwitcher.vue?vue&type=script&lang=js"
import style0 from "./DigitalHumanSwitcher.vue?vue&type=style&index=0&id=487b4cd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487b4cd6",
  null
  
)

export default component.exports